import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import theme from 'theme';
import aiMusicGenerator from 'services/locales/en/aiMusicGenerator';
import {
  StepGuideContainer,
  StepsContainer,
  StepsItemsContainer,
  SideBarTitle,
} from './styled';
import { stepsArray } from './steps';

const StepGuide = () => {
  const { t } = useTranslation();

  return (
    <StepGuideContainer data-testid="ai-result-guide">
      <SideBarTitle variant="h1" data-testid="ai-result-guide-title">
        {t(aiMusicGenerator.sideBar.title)}
      </SideBarTitle>

      <Typography variant="subtitle1" mt={3} fontSize={20}>
        {t(aiMusicGenerator.sideBar.description)}
      </Typography>

      <StepsContainer>
        {stepsArray.map((step, index) => {
          const keyIndex = `${step.title}-${index}`;
          return (
            <StepsItemsContainer key={keyIndex}>
              <Box component={step.icon} sx={{ fontSize: '24px' }} />
              <Typography variant="body2" sx={{ py: 1.5 }}>
                {t(step.title)}
              </Typography>

              <Typography sx={{ color: theme.palette.grey[400] }}>
                {t(step.description)}
              </Typography>
            </StepsItemsContainer>
          );
        })}
      </StepsContainer>
    </StepGuideContainer>
  );
};

export default StepGuide;
